<nav class="navbar navbar-expand-lg navbar-dark static-top nav-custom" *ngIf="isLoggedIn()">
  <div class="container">
    <a class="navbar-brand header-logo" routerLink="/onboarding">
        <img src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1607238429/truventor/tru-logo.png">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto header-links">
        <li class="nav-item">
          <a class="nav-link" *ngIf="isLoggedOut()">Back To Main Website</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" *ngIf="isLoggedOut()" routerLink="/signup">Register</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" *ngIf="isLoggedOut()" routerLink="/login">Login</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" *ngIf="isLoggedIn()" routerLink="/profile">Profile</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="logout()" *ngIf="isLoggedIn()">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
